/** Console v0.5 Organisations: words and small rules (Organisations and Client mock-ups). Pure -- tested with Node. */

export const ORGS_COPY = {
  practiceIntro: "The businesses your practice looks after. Each one has its own ledger, services and team access.",
  companyIntro: "Your business on Preekie. Related entities, such as a trust or a second company, can be added later.",
  practiceAdd: "Add an organisation",
  practiceList: "All organisations",
  companyList: "Your organisation",
  practiceFoot: "Team members only see the organisations they have access to; set this on the Team page.",
  companyFoot: "Group structures with more than one entity are planned for later. Tell us if you need one now.",
  none: "No organisations yet.",
  noMatch: "No organisations match.",
  pinLimit: "You can pin up to 5 organisations.",
} as const;

export const MAX_PINS = 5;

/** Pin or unpin one organisation, keeping the order and the limit of 5 (A: up to 5 different ones). */
export function togglePin(current: readonly string[], id: string): string[] | null {
  if (current.includes(id)) return current.filter((x) => x !== id);
  if (current.length >= MAX_PINS) return null;
  return [...current, id];
}

/** "Plan places left" (practice) from the organisation limit; null when the account has no plan limits. */
export function placesLeft(limits: { used: number; max: number } | null | undefined): number | null {
  return limits ? Math.max(0, limits.max - limits.used) : null;
}

/** Overview tab order (Client mock-up). */
export const ORG_TABS = [
  { id: "overview", label: "Overview" },
  { id: "accounting", label: "Accounting" },
  { id: "tax", label: "Tax" },
  { id: "assurance", label: "Assurance" },
  { id: "financing", label: "Financing" },
] as const;

export type OrgTab = (typeof ORG_TABS)[number]["id"];
